import { useQuery } from '@tanstack/react-query';
import _uniq from 'lodash/uniq';

import { useApi } from 'services/api';
import useStore from 'services/store';
import { getConfiguredTimezone } from 'utils/datetime';

import useCurrentDashboardSearch from './useCurrentDashboardSearch';

export const getInvestigatorDashboardQueryKey = (pqlQuery, context, otherDependencies) => [
  'investigator-dashboard',
  {
    pqlQuery,
    context,
    otherDependencies,
  },
];

export default function useInvestigatorDashboardData({ histogramMql, facetPropKeys, otherDependencies }) {
  const api = useApi();
  const context = useStore((state) => state.searchQuery.activeSensorsByProfile);
  const timezone = getConfiguredTimezone();
  const { pqlQuery } = useCurrentDashboardSearch();

  const queryKey = getInvestigatorDashboardQueryKey(pqlQuery, context, otherDependencies);

  return useQuery({
    queryKey,
    queryFn: () => {
      return api
        .post('/search/investigator', {
          query: pqlQuery,
          timezone,
          facets: _uniq(facetPropKeys).map((propKey) => ({
            propertyName: propKey,
            mqlSnippet: `countby ${propKey} | orderby @count desc limit 101`,
          })),
          context,
          histogram: {
            mqlSnippet: histogramMql,
          },
        })
        .then((r) => ({
          ...r,
          // this is to ensure that it doesn't appear like we're missing a facet or having an extra one
          // its important for the logic in the WidgetArea component
          facets: r.facets?.length ? r.facets : facetPropKeys.map((propKey) => ({ propertyName: propKey, values: [] })),
        }));
    },
    enabled: !!histogramMql && !!context?.length,
  });
}
